import { Chart } from "chart.js";

function readCssHsl(token, fallback) {
  if (typeof document === "undefined") return fallback;
  const raw = getComputedStyle(document.documentElement)
    .getPropertyValue(token)
    .trim();
  return raw ? `hsl(${raw})` : fallback;
}

/**
 * Canvas-friendly theme colors for Chart.js (pie/legend/tooltip/scales).
 */
export function getChartThemeColors() {
  const isDark =
    typeof document !== "undefined" &&
    document.documentElement.classList.contains("dark");

  return {
    isDark,
    foreground: readCssHsl("--foreground", isDark ? "#f8fafc" : "#111827"),
    mutedForeground: readCssHsl(
      "--muted-foreground",
      isDark ? "#a1a1aa" : "#6b7280",
    ),
    card: readCssHsl("--card", isDark ? "#0f1a2e" : "#ffffff"),
    background: readCssHsl("--background", isDark ? "#000814" : "#ffffff"),
    border: readCssHsl("--border", isDark ? "#1e293b" : "#e5e7eb"),
    // Invert surface so tooltips stay high-contrast in both themes
    tooltipBg: readCssHsl("--foreground", isDark ? "#f8fafc" : "#111827"),
    tooltipBorder: readCssHsl("--border", isDark ? "#1e293b" : "#e5e7eb"),
    tooltipTitle: readCssHsl("--background", isDark ? "#000814" : "#ffffff"),
    tooltipBody: readCssHsl("--background", isDark ? "#000814" : "#ffffff"),
    grid: isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.06)",
  };
}

/** Common Chart.js legend + tooltip styling for light/dark. */
export function getChartPluginTheme(theme = getChartThemeColors()) {
  return {
    legend: {
      labels: {
        color: theme.foreground,
      },
    },
    tooltip: {
      backgroundColor: theme.tooltipBg,
      titleColor: theme.tooltipTitle,
      bodyColor: theme.tooltipBody,
      borderColor: theme.tooltipBorder,
      borderWidth: 1,
    },
  };
}

/** Apply site-wide Chart.js defaults so every chart tooltip follows theme. */
export function applyChartJsThemeDefaults() {
  if (typeof document === "undefined" || !Chart?.defaults) return;

  const theme = getChartThemeColors();
  const plugins = getChartPluginTheme(theme);

  Chart.defaults.color = theme.mutedForeground;
  Chart.defaults.borderColor = theme.grid;

  if (Chart.defaults.plugins?.legend?.labels) {
    Object.assign(Chart.defaults.plugins.legend.labels, plugins.legend.labels);
  }
  if (Chart.defaults.plugins?.tooltip) {
    Object.assign(Chart.defaults.plugins.tooltip, plugins.tooltip);
  }
}
